// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import StoryEditor from './js/story-editor-component';
import './assets/css/main.css';
import blobPolyfill from './js/canvas-blob-polyfill';


Vue.config.productionTip = false;

/* eslint-disable no-new */
window.VUEMAINSTK = new Vue({
  el: '#main',
  components: {
    StoryEditor
  },
  data: {
    // :fixme this face points I'm not sure that they needed for me
    facePoints: {
      eyes: [{x: 150, y: 202}, {x: 252, y: 194}],
      mouth: [{x: 162, y: 302}, {x: 237, y: 297}]
    },
    imageSize: {
      width: 360,
      height: 640
    },
    index: null,
    pointsTrigger: true,
    storyObj: null
  },
  methods: {
  },
  mounted() {
  }
});



// WEBPACK FOOTER //
// ./src/main.js